import axios from '@/config/axios'


const walletBase = '/v1/api/mg/wallet'


export const walletTransactions = (query) => axios.get(`${walletBase}/transactions`, {params: query})

export const walletTransactionsExport = (query) => axios.get(`${walletBase}/transactions`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


export const toups = (query) => axios.get(`${walletBase}/toups`, {params: query})

export const exportToups = (query) => axios.get(`${walletBase}/toups`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


export const walletWithdraws = (query) => axios.get(`${walletBase}/withdraws`, {params: query})


export const doWalletWithdraws = (data) => axios.put(`${walletBase}/withdraws`, data)

export const walletWithdrawsExport = (query) => axios.get(`${walletBase}/withdraws`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})


const settleBase = '/v1/api/mg/internalSettle'


export const settleList = (query) => axios.get(`${settleBase}`, {params: query})

export const exportSettleList = (query) => axios.get(`${settleBase}`, {
    params: query,
    headers: {
        Accept: "application/vnd.ms-excel"
    },
    responseType: 'arraybuffer'
})

export const clearSettle = (id) => axios.patch(`${settleBase}/${id}`)

const helperCompanyBase = '/v1/api/mg/helperCompany'


export const helperCompanyList = (query) => axios.get(`${helperCompanyBase}`, {params: query})


export const createHelperCompany = (data) => axios.post(`${helperCompanyBase}`, data)


export const updateHelperCompany = (data) => axios.put(`${helperCompanyBase}`, data)


export const deleteHelperCompany = (id) => axios.delete(`${helperCompanyBase}/${id}`)


const doorApiBase = "/v1/api/mg"


/**
 * 同步门禁系统的门禁列表
 *
 *
 *
 */
export const doorSync = () => axios.post(`${doorApiBase}/doorTasks`)


export const doors = (query) => axios.get(`${doorApiBase}/doors`, {params: query})


export const updateDoor = (id, data) => axios.post(`${doorApiBase}/doors/${id}`, data)




export const deleteDoor = (id) => axios.delete(`${doorApiBase}/doors/${id}`)








